module.exports = __webpack_public_path__ + "img/background046.913d37ff.jpg";